import type { ReactNode } from 'react';

export function ParagraphTitle(props: { children: ReactNode; className?: string }) {
    return <h3 className={props.className || ''}>{props.children}</h3>;
}
